<script lang="ts">
	import ServicePage from "../components/ServicePage.svelte";
	import type { ServiceInspectionProps } from "./ServiceInspectionProps.js";
	import inspection1 from "../assets/images/inspekce-1.jpeg?webp&w=1920&imagetools";
	import inspection2 from "../assets/images/inspekce-2.jpg?webp&w=1920&imagetools";
	import inspection3 from "../assets/images/inspekce-3.jpg?webp&w=1920&imagetools";
	import inspection4 from "../assets/images/inspekce-4.jpg?webp&w=1920&imagetools";

	type $$Props = ServiceInspectionProps;

	const { references, blogPosts } = $$restProps as $$Props;

	const images = [inspection1, inspection2, inspection3, inspection4];

	const heading = "Provedeme inspekci \n vašeho skladu";
	const title =
		"Naše služba inspekce skladovacích systémů zajišťuje pravidelnou kontrolu a údržbu všech regálových a skladovacích zařízení, aby byla zajištěna jejich bezpečnost a dlouhá životnost.";
	const perex =
		"Certifikovaní technici společnosti BITO provádějí detailní prohlídky, identifikují případné \n závady a navrhují opatření k nápravě.";
	const perex2 =
		"Díky pravidelným inspekcím minimalizujete riziko nehod, snížíte náklady na opravy a zajistíte plynulý \n provoz skladu v souladu s bezpečnostními normami a předpisy.";
</script>

<ServicePage {heading} {title} {perex} {perex2} {images} {references} {blogPosts} />
